import { createContext, useContext, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState({});
  const [open, setOpen] = useState(false);

  const add = (item) =>
    setItems((s) => ({ ...s, [item.n]: { item, qty: (s[item.n]?.qty || 0) + 1 } }));

  const dec = (n) =>
    setItems((s) => {
      const q = (s[n]?.qty || 0) - 1;
      const c = { ...s };
      if (q <= 0) delete c[n];
      else c[n] = { ...c[n], qty: q };
      return c;
    });

  const remove = (n) =>
    setItems((s) => {
      const c = { ...s };
      delete c[n];
      return c;
    });

  const clear = () => setItems({});

  const list = Object.values(items);
  const count = list.reduce((a, x) => a + x.qty, 0);
  const subtotal = list.reduce((a, x) => a + x.qty * x.item.p, 0);
  const discount = Math.round(subtotal * 10) / 100;
  const total = Math.round((subtotal - discount) * 100) / 100;

  return (
    <CartCtx.Provider value={{ items: list, add, dec, remove, clear, count, subtotal, discount, total, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
};
